import { useState } from 'react';
import { T } from 'gt-react';
import purchasesSampleUrl from 'src/assets/rebates/purchases-sample.xlsx?url';
import { FileDropzone } from '../../item-master/components/FileDropzone';
import { PURCHASE_FILE_ACCEPT } from './PurchaseUploadDialog';
import { PurchaseTrendUploadSection } from './PurchaseTrendUploadSection';
import type { LastUploadRecord } from './purchaseTrendPage';

const PURCHASES_SAMPLE_FILENAME = 'purchases-sample.xlsx';

function acceptAnyPurchaseFile() {
  return Promise.resolve(null);
}

export function PurchaseTrendFirstUpload({
  open,
  onOpenChange,
  onImported,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImported: (record: LastUploadRecord) => void;
}) {
  const [droppedFile, setDroppedFile] = useState<File | null>(null);

  function handleFileAccepted(file: File) {
    setDroppedFile(file);
    onOpenChange(true);
  }

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      setDroppedFile(null);
    }
    onOpenChange(nextOpen);
  }

  return (
    <div
      className="flex min-h-[60vh] items-center justify-center p-6"
      data-testid="purchase-trend-first-upload"
    >
      <FileDropzone
        className="w-full max-w-xl gap-4 px-10 py-14"
        accept={PURCHASE_FILE_ACCEPT}
        validate={acceptAnyPurchaseFile}
        onFileAccepted={handleFileAccepted}
        buttonLabel={
          <T context="button to choose a purchases file on the empty purchases vs rebates report">
            Upload Purchases
          </T>
        }
      >
        <p className="max-w-sm text-sm text-muted-foreground">
          <T context="instructions under the Upload Purchases button when no purchases file exists; the link downloads a sample workbook">
            Upload an Excel workbook with a <strong>Detail</strong> sheet and a{' '}
            <strong>Division</strong> sheet.{' '}
            <a
              href={purchasesSampleUrl}
              download={PURCHASES_SAMPLE_FILENAME}
              className="font-medium text-primary underline-offset-4 hover:underline"
              data-testid="purchases-sample-download"
            >
              Download the sample file
            </a>{' '}
            to see the columns this report needs.
          </T>
        </p>
      </FileDropzone>
      <PurchaseTrendUploadSection
        canUpload
        open={open}
        onOpenChange={handleOpenChange}
        onImported={onImported}
        initialFile={droppedFile}
      />
    </div>
  );
}
